import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { formatRoute } from 'react-router-named-routes'
import routes from 'constants/routes' // TODO delete after links are reworked

/* components */
import FlagCountry from 'components/common/FlagCountry'
import StarsRating from 'components/common/StarsRating'

/* helpers */
import getImagePath from 'helpers/get-image-path'

/* styles */
import classes from 'pages/sheared/Missions/Mission/index.module.scss'

const Mission = ({
  // link,  // TODO uncomment after links are reworked
  photos,
  name,
  location,
  rating,
  reviewsCount,
  slug,
  end_date: endDate,
  dontShowScore,
}) => {
  const missionIsEnded = new Date(endDate) < new Date()

  return (
    <div className={classes.missionWrapper}>
      <Link to={{ pathname: formatRoute(routes.mission, { slug }) }} className={classes.missionLink}>
        <div className={clsx(classes.mission, missionIsEnded && classes.ended)}>
          <div className={clsx(classes.missionImageWrapper)}>
            <img
              className={classes.missionImage}
              src={getImagePath({ imageData: photos[0], size: '270x160' })}
              alt={name}
            />
          </div>
          <h4 className={classes.missionTitle} title={name}>
            {name}
          </h4>
          <FlagCountry
            locationClassName={classes.locationClassName}
            locationFull={location?.city?.name ?// eslint-disable-next-line camelcase
              `${location?.city?.name}, ${location.country?.international_name || ''}` :// eslint-disable-next-line camelcase
              `${location.country?.international_name || ''}`}
            locationAbbr={location?.country?.code.toLowerCase()}
          />
        </div>
      </Link>

      {(!!rating.score && reviewsCount) && !dontShowScore && (
        <div className={classes.missionBottomBlock}>
          <StarsRating rating={rating.score} />
          <Link to={slug}>
            <span className={classes.missionReviewsCount}>{reviewsCount} reviews</span>
          </Link>
        </div>
      )}

    </div>
  )
}

Mission.propTypes = {
  // link: PropTypes.string,    // TODO uncomment after links are reworked
  photos: PropTypes.array,
  name: PropTypes.string,
  location: PropTypes.object,
}

Mission.defaultProps = {
  // link: '',  // TODO uncomment after links are reworked
  photos: [],
  name: '',
  location: '',
  isEnd: false,
}

export default Mission
